<template>
    <div></div>
</template>

<script>
    import {enum_urlParams} from "../../../functions/src/shareCode/Share_S_Enum";
    import {route_getUrlParams} from "@/router";

    export default {
        name: "v_IframeSuccessMsg",
        created(){

            const msg = route_getUrlParams(this.$route, enum_urlParams.msg)

            // send ticketID to parent
            console.log("v_IframeSuccessMsg", {msg})
            window.parent.postMessage({msg}, "*");

        },
    }
</script>

<style scoped>

</style>